import { keymap } from 'prosemirror-keymap';
import { EditorView } from 'prosemirror-view';

import { EditorButton, RtPMPlugin } from '../../../editor/types';
import { MarkService, toggleMark } from '../../../helpers/mark-base';
import { DEFAULT_KEYMAP_INPUTRULE_PRIORITY } from '../../../helpers/utils';
import { UnderlineSchema } from './underline-mark';

export class UnderlineService<S extends UnderlineSchema> extends MarkService<S> {}

export class UnderlinePlugin implements RtPMPlugin {
  public api: {
    underlineService: UnderlineService<UnderlineSchema>;
  };
  public buttons = {
    toggleUnderline: <EditorButton>{
      icon: 'format-underlined',
      isActive: (...args) => this.api.underlineService.isActive(...args),
      run: (state, dispatch) => {
        this.api.underlineService.toggle(state, dispatch);
        this.editorView.focus();
      },
    },
  };

  private editorView: EditorView<UnderlineSchema>;

  public beforeEditorInit(schema: UnderlineSchema) {
    this.api = {
      underlineService: new UnderlineService(schema.marks.underline),
    };
  }

  public afterEditorInit(editorView: EditorView<UnderlineSchema>) {
    this.editorView = editorView;
  }

  public getNativeEditorPlugins(schema: UnderlineSchema) {
    return [
      { priority: DEFAULT_KEYMAP_INPUTRULE_PRIORITY, plugin: keymap(this.getKeyBindings(schema)) },
    ];
  }

  private getKeyBindings(schema: UnderlineSchema) {
    return {
      'Mod-U': toggleMark(schema.marks.underline),
      'Mod-u': toggleMark(schema.marks.underline),
    };
  }
}
